import service from '@/services/service'
import { APIAuth, APIResetPassword } from '@/models/api/auth.model'

export class AuthServices {
    public static login (credentials: APIAuth) {
        return service.post('/auth-services/auth/login', credentials)
    }

    public static sendPin (email: string) {
        return service.post('/auth-services/auth/send-pin', { email })
    }

    public static resetPasswordPin (data: APIResetPassword) {
        return service.post('/auth-services/auth/reset-password', data)
    }
}
